import React, { useContext, useState } from "react";
import { Box, OldButton as Button } from "digiwash-components";
import { Image } from "react-native";
import { useSelector } from "react-redux";

import { LoginContext } from "../../contexts/login";
import userSelectors from "../../ducks/user/selectors";
import { TouchableOpacity } from "react-native";
import Icon from "../../components/Icon";
import { Typography, Stack, Spacer } from "digiwash-components";
import { formatPrice } from "../../helpers/number";
import SubscriptionModal from "../../components/SubscriptionModal";
import useProfile from "../../ducks/user/hooks/useProfile";
import PageContainerShape from "../../containers/PageContainerShape";
import CustomIcon from "../CustomIcon";

function crossPlatformProfilePictureImport() {
  let asset = require(`../../resources/profile-picture.png`);
  return asset?.default || asset;
}

let profilePicture = crossPlatformProfilePictureImport();

function HeaderWorkspace() {
  let { data, workspaces } = useProfile();
  let { setLoginModalOpen } = useContext(LoginContext);
  let authenticated: boolean = useSelector(userSelectors.getToken);
  let [openModal, setOpenModal] = useState(false);
  let hasWorkspace = workspaces?.list?.length > 1;

  return authenticated ? (
    <Box bg="primary.main">
      <PageContainerShape>
        {data && workspaces.activeWorkspace ? (
          <TouchableOpacity
            onPress={() => {
              if (hasWorkspace) {
                setOpenModal(true);
              }
            }}
          >
            <Stack distribution="space-between">
              {workspaces.activeWorkspace.id === "personal" ? (
                <CustomIcon icon="avatar" width={48} height={48} />
              ) : (
                <Box pl="m">
                  <Image
                    source={workspaces.activeWorkspace.logo}
                    style={{ width: 48, height: 48 }}
                  />
                </Box>
              )}

              <Box pr="m" style={{ flexGrow: 1 }}>
                <Typography color="common.black" fs="m" ff="mainBold">
                  {workspaces.activeWorkspace.name}
                </Typography>

                <Stack>
                  <Typography color="primary.dark" fs="s" ff="mainBold">
                    {formatPrice(data.total_balance)} تومان اعتبار
                  </Typography>
                  <Spacer size="m" />
                  {hasWorkspace ? (
                    <Icon
                      name="chevron-down"
                      size={20}
                      color={"common.black"}
                    />
                  ) : null}
                </Stack>
                {hasWorkspace ? (
                  <SubscriptionModal
                    workspaces={workspaces.list}
                    activeWorkspace={workspaces.activeWorkspace.id}
                    onSelect={(selectWorkspace) => {
                      workspaces.changeActiveWorkspace(selectWorkspace);
                      setOpenModal(false);
                    }}
                    onDismiss={() => {
                      setOpenModal(false);
                    }}
                    isModalOpen={openModal}
                  />
                ) : null}
              </Box>
            </Stack>
          </TouchableOpacity>
        ) : null}
      </PageContainerShape>
    </Box>
  ) : (
    <Box bg="common.white">
      <PageContainerShape>
        <Stack distribution="space-between">
          <Box pl="m">
            <Image source={profilePicture} style={{ width: 48, height: 48 }} />
          </Box>
          <Box pr="m" style={{ flexGrow: 1 }}>
            <Typography color="common.black" fs="m" ff="mainBold">
              دیجی واش من
            </Typography>
            <Typography color="primary.dark" fs="s" ff="mainBold">
              وارد حساب کاربری خود شوید
            </Typography>
          </Box>
          <Box>
            <Button
              bg="primary.main"
              size="m"
              type="circle-like"
              onPress={() => {
                setLoginModalOpen(true);
              }}
            >
              <Typography color="common.white" fs="xm">
                ثبت نام/ ورود
              </Typography>
            </Button>
          </Box>
        </Stack>
      </PageContainerShape>
    </Box>
  );
}

export default HeaderWorkspace;
